import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography, Modal, Space, Row, Col, Table, Icon, Avatar, InputNumber } from 'antd'
import moment from 'moment'
import { alertMessage } from '../../../../../utils/message'
import ModalConfirmForm from '../../../../../components/user/ModalConfirmForm'

const { Text, Title } = Typography
const { TextArea } = Input;
const formItemLayout = {
	// labelCol: {
	//   xs: { span: 24 },
	//   sm: { span: 9 },
	// },
	// wrapperCol: {
	//   xs: { span: 24 },
	//   sm: { span:15 },
	// },
  };

class ModalForm2 extends Component {
	state = {
		dataTable:[],
        columns:[
            {
                title: 'คนที่',
                dataIndex: 'listNo',
				align:'center',
                vertical:'top',
                width:60,
                render: (item, record, index) => item
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>ชื่อ - นามสกุล <span class="color-red">*</span></span>
                },
                dataIndex: 'benefitsName',
				align:'center',
                vertical:'top',
                render: (item, record, index) => {
                    return <>
                                <Form.Item label={""} className="mb-0">
                                    { this.props.form.getFieldDecorator("benefitsName"+index, {
                                        initialValue: item,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ ชื่อ - นามสกุล',
                                        }],
                                    })(
                                        <Input 
                                            // defaultValue={item} 
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsName') }
                                        />
                                    )}
                                </Form.Item>
                            </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>เลขที่บัตรประชาชน</span>
                },
                dataIndex: 'benefitsIdCard',
				align:'center',
                vertical:'top',
                width:160,
                render: (item, record, index) => {
                    return <>
                                <Form.Item label={""} className="mb-0">
                                    { this.props.form.getFieldDecorator("benefitsIdCard"+index, {
                                        initialValue: item,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ เลขที่บัตรประชาชน',
                                        }],
                                    })(
                                        // <Input 
                                        //     // defaultValue={item} 
                                        //     max={13}
                                        //     onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsIdCard') }
                                        // />
                                        <InputNumber 
                                            // step={1000.01}
                                            // disabled={ record.wdSlipId ? checkDisbledInput(this.state.statusCanEdit, "totalPrice") ? true : false : false }
                                            formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, '')}
                                            // min={0.00}
                                            maxLength={13}
                                            parser={item => item.replace(/\$\s?|(,*)/g, '')}
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsIdCard') }
                                            className="input-number"
                                        />
                                    )}
                                </Form.Item>
                            </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>เปอร์เซ็นต์<br></br>ที่ได้รับ <span class="color-red">*</span></span>
                },
                dataIndex: 'benefitsRate',
				align:'center',
                vertical:'top',
                width:130,
                render: (item, record, index) => {
                    return <>
                            <Form.Item label={""} className="mb-0">
                                { this.props.form.getFieldDecorator("benefitsRate"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        required: true, 
                                        message: 'กรุณาระบุ เลขที่ใบเสร็จ',
                                    }],
                                })(
                                    <InputNumber 
                                        step={1000.01}
                                        // disabled={ record.wdSlipId ? checkDisbledInput(this.state.statusCanEdit, "totalPrice") ? true : false : false }
                                        formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        min={0.00}
                                        max={100}
                                        parser={item => item.replace(/\$\s?|(,*)/g, '')}
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsRate') }
                                        className="input-number"
                                    />
                                )}
                            </Form.Item>
                        </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>ที่อยู่ </span>
                },
                dataIndex: 'address',
                dataIndex: '7',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
							<Form.Item label={""} className="mb-0">
                                { this.props.form.getFieldDecorator("address"+index, {
                                    initialValue: item,
                                    // getValueFromEvent: value =>{
                                    //     return value && value !== '0' && value !== '-' ? value : ''
                                    // },
                                    rules:  [{ 
                                        required: false, 
                                        message: 'กรุณาระบุ ที่อยู่',
                                    }],
                                })(
                                    <TextArea 
                                        className="mt-1"
                                        // defaultValue={item} 
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'numberSlip') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return  this.showInputBtn(record, index)
                }
            },
        ],
        nameImage: null
	}

    onChangeValueForm = async (arrayId, values, name) =>{
        const { dataTable } = this.state
        let dataSourceitems = [...this.state.dataTable];
        let item = {...dataSourceitems[arrayId]};

        console.log('values',values)
        if(name == 'benefitsName'){
            item.benefitsName = values.target.value
        }else if(name == 'benefitsIdCard'){
            item.benefitsIdCard = values.target.value
        }else if(name == 'benefitsRate'){
            item.benefitsRate = values.target.value
        }else if(name == 'address'){
            item.address = values.target.value
        }
        dataSourceitems[arrayId] = item;

        await this.setState({
            dataTable:dataSourceitems
        },async () => {
            // await this.setSummary()
            // await this.setSummarySlipWithdraw()
            // await this.onChangeValueTotalCurrentWithdraw()
			// this.cllBackSetValueContactNumber()
        })
    }

    showInputBtn = (record, arrayId) =>{
        return  (
                    <>
                        {
                            record.id ? 
                                <Avatar 
                                    disabled={true}
                                    shape="square"  
                                    icon={<Icon type="delete" />} 
                                    className="bg-red mt-2"  
                                    style={{ cursor: 'not-allowed' }}
                                />
                            :
                                <Avatar 
                                    shape="square"  
                                    icon={<Icon type="delete" />} 
                                    className="mr-1 mb-1 bg-red"  
                                    onClick={ () => this.destroyArrayData(arrayId) }
                                    style={{ cursor: 'pointer', background:"red" }}
                                />
                        }
                    </>
                )
    }

    destroyArrayData =  async (arrayId) =>{
        const { dataTable } = this.state
        
        var arrayDataSource = [...this.state.dataTable];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTable:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            // await this.setRowTableSammary()

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let listNo = `listNo${keysTable}`
                let benefitsName = `benefitsName${keysTable}`
                let benefitsIdCard = `benefitsIdCard${keysTable}`
                let benefitsRate = `benefitsRate${keysTable}`
                let address = `address${keysTable}`


                await this.props.form.setFieldsValue({
                    [listNo]: valuesTable.listNo,
                    [benefitsName]: valuesTable.benefitsName,
                    [benefitsIdCard]: valuesTable.benefitsIdCard,
                    [benefitsRate]: valuesTable.benefitsRate,
                    [address]: valuesTable.address,
                });
            })
		})
    }

    handleAddImages = async (images ) => {
        if(images){
            let imagesData = images

            console.log('images', imagesData[0].name)

            await this.setState({
                nameImage: imagesData[0].name,
                fileData: imagesData[0]
            })
        }
	}

    showDataInput = async () =>{
        const { dataTable, reqAttachDayStatus } = this.state
        console.log('dataTable',dataTable.length)
        const rows = {
            listNo: dataTable.length+1,
            benefitsName: null,
            benefitsIdCard: null,
            benefitsRate: null,
            address: null,
        }
        await this.setState(prevState => ({
            dataTable: [...prevState.dataTable, rows],
        }), async () => {
            let lengthData = dataTable.length+1;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })
        })
    }

    showModalConfirm = async (e) =>{
		const { configDataProvPercentage, statusForm, dataTable } = this.state
        let ModalConfirmFormTitle = ''
		e.preventDefault()
		this.props.form.validateFields( async(err, values) => {
            if (!err) {
                const sum = (dataTable).reduce((accumulator, object) => {
                    return accumulator + parseFloat(object.benefitsRate);
                }, 0);
                var valueArr = (dataTable).map((item) => { return item.benefitsName.replace(/ /g, "") });
                
                var isDuplicate = valueArr.some((item, idx) => {
                    return valueArr.indexOf(item) != idx
                });


                if (sum !== 100) {
                    alertMessage('error', 'เปอร์เซนต์ที่ได้รับรวมกันต้อง 100%')
                }else if (isDuplicate) {
                    alertMessage('error', 'ชื่อบุคคลผู้รับผลประโยชน์ซ้ำ')
                } else {
                    if(statusForm == 'DRAFT'){
                        ModalConfirmFormTitle = 'ยืนยันการบันทึก'
                    }else if(statusForm == 'PENDING'){
                        ModalConfirmFormTitle = 'ยืนยันการเปลี่ยนแปลงการหักเงินสะสม'
                    }else if(statusForm == 'CANCEL'){
                        ModalConfirmFormTitle = 'ยืนยันการยกเลิกการเปลี่ยนแปลงการหักเงินสะสม'
                        // alertMessage("success","ทำการยกเลิกการเปลี่ยนแปลงข้อมูลการหักเงินสะสมเรียบร้อย")
                    }

                    await this.setState({
                        ModalConfirmFormTitle,
                        ModalConfirmFormShowModal:true,
                        ModalConfirmFormBtnOk:"ตกลง",
                        ModalConfirmFormBtnCancel:'ยกเลิก',
                        ModalConfirmFormValue:values,
                        ModalConfirmFormStatus: null,
                        ModalConfirmFormMessage: null,
                        ModalFormTextArea: null,
                        ModalFormTextAreaRequie: null
                    })
                }
            }
		});
	}

    hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
            ModalConfirmFormMessage:null,
            preLoadOnsubmit: false
        })
    }

	render() {
		const { modalCondition2, hideModalCondition2 } = this.props
		const { getFieldDecorator } = this.props.form;
		const { 
                dataTable, 
                columns, 
                nameImage,
                ModalConfirmFormTitle,
                ModalConfirmFormSubTitle,
                ModalConfirmFormShowModal,
                ModalConfirmFormBtnOk,
                ModalConfirmFormBtnCancel,
                ModalConfirmFormValue,
                ModalFormTextArea,
                ModalFormTextAreaRequie
            } = this.state
		return (
			<>
                <ModalConfirmForm 
					title={ModalConfirmFormTitle} 
					subtitle={ModalConfirmFormSubTitle}
					showModal={ModalConfirmFormShowModal} 
					btnOk={ModalConfirmFormBtnOk} 
					btnCancel={ModalConfirmFormBtnCancel}  
					submitToSend={ this.handleSubmit }
					hideModal={ this.hideModalConfirm }
					valueConfirm = { ModalConfirmFormValue }
					ModalFormTextArea = {ModalFormTextArea}
					ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
				/>

				<Modal
					destroyOnClose={true}
                    maskClosable={false}
					visible={modalCondition2}
					// visible={true}
					title={ <p className="color-red mb-0">เปลี่ยนแปลงข้อมูลผู้รับผลประโยชน์</p> }
					// onOk={this.handleOk}
					onCancel={ hideModalCondition2 }
					width={1100}
					footer={''}
				>
					<>
						<Form {...formItemLayout} ref={this.formRef}  onSubmit={this.showModalConfirm}>
                            <Row gutter={16} type="flex" justify="left" align="top" className="">
                                <Col xs={24} md={24} className="mb-3">
                                    <strong className="color-red">
                                        เงื่อนไขการได้รับผลประโยชน์ *
                                    </strong>
                                    <p>
                                        เลือกจ่ายตามสัดส่วนที่ระบุไว้ ให้กำหนดสัดส่วนรวมให้ครบ 100%
                                    </p>
                                </Col>
								<Col xs={24} md={24} align={"right"}>
                                    <Table
                                        columns={columns}
                                        dataSource={dataTable}
                                        pagination={false}
                                        className="mb-3"
                                        bordered
                                        // rowCount={dataTalbeUploadsDocument.length}
                                        // pagination={{ pageSize: dataTalbeUploadsDocument.length }}
                                    />
                                    
                                </Col>
                                <Col xs={24} md={12} align={"left"}>
                                    <Button 
                                        style={{ display:"inline-block" }}
                                        type="primary btn-color-default btn-clear color-white" 
                                        className="mt-1 mr-2 px-4"
                                        // onClick={ () => this.showDataInputUploadsDocument() }
                                    >
                                        พิมพ์ใบกองทุนสำรองเลี้ยงชีพ
                                    </Button>
                                    
                                </Col>
                                <Col xs={24} md={12} align={"right"}>
                                    <Button 
                                        style={{ display:"inline-block" }}
                                        type="primary btn-color-default btn-clear color-white" 
                                        className="mt-1 mr-2 px-4"
                                        onClick={ () => this.showDataInput() }
                                        disabled={ dataTable.length == 4 ? true : false }
                                    >
                                        เพิ่มผู้รับผลประโยชน์ +
                                    </Button>
                                </Col>
                                <Col md={24}>
                                    <p className="color-red mt-3">
                                        กรุณาพิมพ์เอกสารใบกองทุนสำรองเลี้ยงชีพ และเซ็นลายเซ็นของตัวเองก่อนแนบกลับมายังระบบ โดยแนบเป็นเอกสารสีเท่านั้นในช่องเอกสารแนบด้านล่าง
                                    </p>
                                </Col>
                            </Row>

                            <Row className="my-4">
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col xs={24} md={24} className="mb-3">
                                    <strong className="color-red">
                                        เอกสารแนบ
                                    </strong>
                                </Col>
                                <Col md={5}>
                                    <Form.Item 
                                        label="ประเภทเอกสารแนบ" 
                                        labelAlign="left" 
                                        className="mb-1"
                                        labelCol={{
                                            sm: { span: 24 },
                                          }}
                                    >
                                    </Form.Item>
                                </Col>
                                <Col md={18}>
                                    <div style={{ width:"59%", display:"inline-block", verticalAlign:"top" }}>
                                        <Input value={nameImage} />                                                    
                                    </div>
                                    <div style={{ display:"inline-block" }}>
                                        <label for={"input-fileDocument"} class="custom-file-upload" style={{ width:"180px", display:"block" }}>
                                            <p className="py-2 px-4 mb-1"  align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff", height:"32px" }}>
                                                เลือกไฟล์
                                            </p>
                                            <p style={{ fontSize:"12px", textAlign:"center" }}>แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                                        </label>
                                        <input
                                            id={"input-fileDocument"}
                                            className="input-file"
                                            // multiple
                                            // name={uploadName}
                                            type="file"
                                            accept="file_extension"
                                            // rules={ true }
                                            onChange={e => this.handleAddImages(e.target.files)}
                                            accept="image/png, image/jpeg, application/pdf"
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col md={20} className="p-3"  style={{ backgroundColor:"rgb(250 250 250)" }}>
                                    <p className="mb-0">เอกสารประกอบการเปลี่ยนแปลงข้อมูลผู้รับผลประโยชน์1.pdf</p>
                                </Col>
                                <Col md={2}  className="p-3" align={"center"} style={{ backgroundColor:"rgb(250 250 250)" }}>
                                    <Icon type="eye" />
                                </Col>
                                <Col md={2}  className="p-3" align={"center"} style={{ backgroundColor:"rgb(250 250 250)" }}>
                                    <Icon type="delete" />
                                </Col>
                            </Row>
                           
							<Row className="mt-5">
								<Col style={{ textAlign:"center"}}>
                                    <Button className="btn-white-red" onClick={hideModalCondition2}>
										ปิด
									</Button>
									<Button 
										className="mx-2 btn-white-red" 
										onClick={async () => await this.setState({
											statusForm: "DRAFT"
										})}
										type="primary" 
										htmlType="submit" 
									>
										บันทึก
									</Button>
									<Button 
										type="primary" 
										htmlType="submit" 
										className="color-white"
										onClick={async () => await this.setState({
											statusForm: "PENDING"
										})}
									>
										ส่งดำเนินการ
									</Button>
								</Col>
							</Row>
                        </Form>
                    </>
				</Modal>
			</>
		)
	}
}

ModalForm2.defaultProps = {
	autoFocus: false
}

ModalForm2.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedModalForm2 = Form.create()(ModalForm2)

export default withApollo(WrappedModalForm2)